import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=6d70e17c&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"
import style0 from "./Step4.vue?vue&type=style&index=0&id=6d70e17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70e17c",
  null
  
)

export default component.exports